<router-outlet></router-outlet>
<toaster-container [toasterconfig]="toasterconfig"></toaster-container>
<app-loading></app-loading>